// language=GraphQL
export const ALL_NEWSLETTER_PROVIDERS_QUERY = `query Query($withConfig: Boolean = false) {
  newsletterProviders: newsletterProviders {
    id
    provider
    config @include(if: $withConfig) {
      __typename
      ... on MailchimpConfig {
        id
        apiKey
        serverPrefix
        listId

      }
    }
  }
}`

// language=GraphQL
export const SINGLE_NEWSLETTER_PROVIDER_QUERY = `query Query($id: ID!, $withConfig: Boolean = false) {
  newsletterProvider: newsletterProvider(id: $id) {
    id
    provider
    config @include(if: $withConfig) {
      __typename
      ... on MailchimpConfig {
        id
        apiKey
        serverPrefix
        listId

      }
    }
  }
}`

// language=GraphQL
export const CREATE_NEWSLETTER_PROVIDER_MUTATION = `
  mutation Mutation($input: CreateNewsletterProviderInput, $withConfig: Boolean = false) {
    newsletterProvider: createNewsletterProvider(input: $input) {
      id
      provider
      config @include(if: $withConfig) {
        __typename
        ... on MailchimpConfig {
          id
          apiKey
          serverPrefix
          listId

        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_NEWSLETTER_PROVIDER_MUTATION = `
  mutation Mutation($input: UpdateNewsletterProviderInput, $withConfig: Boolean = false) {
    newsletterProvider: updateNewsletterProvider(input: $input) {
      id
      provider
      config @include(if: $withConfig) {
        __typename
        ... on MailchimpConfig {
          id
          apiKey
          serverPrefix
          listId

        }
      }
    }
  }`

// language=GraphQL
export const DELETE_NEWSLETTER_PROVIDER_MUTATION = `
  mutation Mutation($input: DeleteNewsletterProviderInput) {
    deleteNewsletterProvider(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_NEWSLETTER_PROVIDER_MUTATION = `
  mutation Mutation($input: DeleteNewsletterProviderInput) {
    forceDeleteNewsletterProvider(input: $input) {
      success
    }
  }`
// language=GraphQL
export const NEWSLETTER_PROVIDERS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTenants: Boolean = false) {
  groupedDependents: newsletterProviderDependents(id: $id) {
    tenants @include(if: $withTenants) {
      id
      name
      slug
      domain
      externalReference
    }
  }
}`
